﻿import * as React from "react";

export interface IButtonProps {
    anchorLink?: string;
    className?: string;
    iconSrc?: string;
    onClick?(event: React.SyntheticEvent);
    text?: string;
    value?: string;
}

export const Button: React.FunctionComponent<IButtonProps> = (
    props,
): React.ReactElement => (
    <a href={props.anchorLink}>
        <button
            className={props.className}
            onClick={props.onClick}
            value={props.value}
        >
            {props.iconSrc && <img src={props.iconSrc} />}
            {props.text}
        </button>
    </a>
);
